var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "accordion", class: { "add-padding": !_vm.collapsed } },
    [
      _c("div", { staticClass: "accordion__title" }, [
        _c("a", { on: { click: _vm.toggleCollapsed } }, [
          _vm._v(_vm._s(_vm.header) + " "),
          _c("img", {
            staticClass: "accordion-activator",
            class: { rotate: _vm.collapsed },
            attrs: {
              src:
                "data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23002664' d='M12 2c0-.1 0-.1-.1-.2L10.3.1c-.1-.1-.3-.1-.4 0L6 4 2.1 0c-.1 0-.3 0-.4.1L.1 1.7c-.1.1-.1.3 0 .4l5.7 5.8c.1.1.3.1.4 0l5.7-5.8c.1 0 .1-.1.1-.1z'/%3E%3C/svg%3E"
            }
          })
        ])
      ]),
      _c(
        "div",
        { staticClass: "accordion__body", class: { collapse: _vm.collapsed } },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }